export interface JobInfo {
  formattedJobType: string;
  retryEndpoint: string;
}

const deleteTeamJobInfo: JobInfo = {
  formattedJobType: "Delete team",
  retryEndpoint: "delete_team",
};

const JobMapping = new Map<string, JobInfo>([
  ["DELETE_TEAMS", deleteTeamJobInfo],
]);

export default JobMapping;
